<template>
  <v-container fluid>
    <material-card
      heading="SMTP설정"
      icon-small
      icon="mdi-email-outline"
      title="SMTP설정"
      color="primary"
    >
      <v-form v-model="isFormValid">
        <v-row
          class="mx-5"
        >
          <v-col
            cols="12"
            xl="2"
          >
            <v-select
              v-model="smtp.serviceName"
              label="서비스"
              :items="items"
              outlined
              dense
              :rules="[rules.required]"
            />
          </v-col>

          <v-col
            cols="12"
            xl="2"
          >
            <v-text-field
              v-model="smtp.host"
              color="primary"
              label="IP"
              outlined
              dense
              :rules="[rules.required]"
            />
          </v-col>

          <v-col
            cols="12"
            xl="2"
          >
            <v-text-field
              v-model="smtp.port"
              color="primary"
              label="Port"
              outlined
              dense
              :rules="[rules.required, rules.number]"
            />
          </v-col>
          <v-col
            cols="12"
            xl="2"
          >
            <v-text-field
              v-model="smtp.userName"
              color="primary"
              label="ID"
              outlined
              dense
              :rules="[rules.required, rules.email]"
            />
          </v-col>
          <v-col
            cols="12"
            xl="2"
          >
            <v-text-field
              v-model="smtp.password"
              color="primary"
              label="Password"
              outlined
              dense
              type="password"
              :rules="[rules.required]"
            />
          </v-col>
          <v-col
            cols="12"
            xl="2"
          >
            <div style="float: left;">
              <div style="float: left; margin-top: -10px; margin-right: 10px;">
                <v-switch
                  v-model="smtp.isUse"
                />
              </div>
              <div style="float: left;">
                <v-btn
                  :disabled="!isFormValid"
                  color="primary"
                  @click="saveSMTP"
                >
                  SMTP 정보 저장
                </v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </material-card>
  </v-container>
</template>
<script>
  import { isValidateChcker, snackbarOpen } from '@/util/helpers'

  export default {

    data: () => ({
      heading: '',
      loading: false,
      isFormValid: false,
      items: [
        {
          text: 'Gmail',
          value: 'gmail',
        },
        {
          text: 'Naver',
          value: 'naver',
        },
      ],
      setting: null,
      smtp: {
        isUse: false,
        serviceName: null,
        host: null,
        port: null,
        userName: null,
        password: null,
      },
      rules: {
        ipAddress: isValidateChcker.ipAddress,
        required: isValidateChcker.required,
        number: isValidateChcker.number,
        email: isValidateChcker.email,
      },
    }),

    created () {
      this.heading = this.$t('page.settings')
    },

    mounted () {
      this.getSetting()
    },

    methods: {
      async getSetting () {
        await this.$http.get('/api/v1/settings').then(response => {
          this.setting = response.data
          if (this.setting !== null && this.setting.smtp) {
            this.smtp = this.setting.smtp
          }
        }).catch(err => {
          console.log(err)
        })
      },
      async saveSMTP () {
        if (this.setting !== null) {
          this.setting.smtp = this.smtp
        } else {
          this.setting = {
            smtp: this.smtp,
          }
        }
        await this.$http.post('/api/v1/settings', this.setting).then(response => {
          snackbarOpen('success', 'SMTP 정보가 저장되었습니다.', 'success')
        }).catch(error => {
          console.log(error)
        })
      },
    },
  }
</script>

<style scoped>

</style>
